import Phaser from 'phaser';

class ZoomControls extends Phaser.Scene {
  constructor(config = 'ZoomControls') {
    super(config);
  }
  init(data) {
    this.camera = data.camera;
    this.default = data.default;
    this.world = data.world;
    this.cameraInitComplete = data.cameraInitComplete;
    if (this.game.datgui) {
      if (this.world) {
        this.game.worldZoomGuage = this.game.datgui
          .add(this.camera, 'zoom', 0.25, 12, 0.25)
          .name('World Zoom');
      } else {
        this.game.zoomGuage = this.game.datgui
          .add(this.camera, 'zoom', 0.25, 12, 0.25)
          .name('Camera Zoom');
      }
    }
  }
  create() {
    this.setZoom(this.default);
  }
  setZoom(zoom) {
    const alreadyThere = this.camera.zoom === zoom;
    alreadyThere
      ? this.cameraInitComplete && this.cameraInitComplete()
      : this.camera.zoomTo(zoom, 300, 'Expo.easeOut', true, (cam, progress) => {
          if (progress === 1) {
            setTimeout(this.cameraInitComplete, 400);
          }
        });
  }
  update() {
    this.game.zoomGuage && this.game.zoomGuage.updateDisplay();
    this.game.worldZoomGuage && this.game.worldZoomGuage.updateDisplay();
  }
}

export default ZoomControls;
